<div class="bg-white p-6" style="min-width: 400px;">
  <!-- Title -->
  <h2 class="text-lg font-semibold mb-4 text-gray-900">{{ title }}</h2>

  <!-- Message -->
  <div class="text-gray-700 mb-6">
    <ng-container *ngFor="let block of messageBlocks">
      <p *ngIf="block.type === 'p'" class="mb-3">{{ block.text }}</p>
      <ul *ngIf="block.type === 'ul'" class="list-disc pl-6 mb-3 space-y-1">
        <li *ngFor="let item of block.items">{{ item }}</li>
      </ul>
    </ng-container>
  </div>

  <!-- Actions -->
  <div class="flex justify-end space-x-3">
    <button 
      *ngIf="cancelButton"
      mat-button 
      (click)="onDismiss()"
      color="primary"
      class="px-4 py-2">
      {{ cancelButton }}
    </button>
    <button 
      mat-button 
      (click)="onConfirm()" 
      cdkFocusInitial
      [color]="confirmButtonColor"
      class="px-4 py-2">
      {{ confirmButton }}
    </button>
  </div>
</div>
